import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ff4de84"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "ほげほげさん"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createElementVNode("small", null, "1:23 AM")
], -1 /* HOISTED */))
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " ほげほげほげほげほげほげほげほげ。 ", -1 /* HOISTED */))
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Reaction = _resolveComponent("Reaction")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`preview ${_ctx.darkMode ? 'dark' : 'light'}`)
  }, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (row, i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "row"
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (col, j) => {
          return (_openBlock(), _createElementBlock("img", {
            key: j,
            class: _normalizeClass(`img large ${ _ctx.rounded ? 'mi2' : ''}`),
            src: col
          }, null, 10 /* CLASS, PROPS */, _hoisted_2))
        }), 128 /* KEYED_FRAGMENT */))
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _hoisted_3,
    _createElementVNode("div", null, [
      _createTextVNode(" 文章中で使うとこんな "),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (row, i) => {
        return (_openBlock(), _createElementBlock("span", { key: i }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (col, j) => {
            return (_openBlock(), _createElementBlock("img", {
              key: j,
              class: _normalizeClass(`img in_text ${ _ctx.rounded ? 'mi2' : ''}`),
              src: col
            }, null, 10 /* CLASS, PROPS */, _hoisted_4))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      }), 128 /* KEYED_FRAGMENT */)),
      _createTextVNode(" 感じ。 ")
    ]),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (row, i) => {
        return (_openBlock(), _createElementBlock("span", { key: i }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (col, j) => {
            return (_openBlock(), _createBlock(_component_Reaction, {
              key: j,
              src: col,
              rounded: _ctx.rounded
            }, null, 8 /* PROPS */, ["src", "rounded"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ], 2 /* CLASS */))
}